const STORAGE_KEY = 'bliss_bunk_bed_orders';

export function saveOrder(order) {
  const orders = getAllOrders();
  const existingIndex = orders.findIndex(o => o.orderNumber === order.orderNumber);
  
  if (existingIndex >= 0) {
    orders[existingIndex] = order;
  } else {
    orders.push(order);
  }
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(orders));
  localStorage.setItem('lastOrderNumber', order.orderNumber);
}

export function getAllOrders() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : [];
}

export function getOrder(orderNumber) {
  const orders = getAllOrders();
  return orders.find(o => o.orderNumber === orderNumber);
}

export function deleteOrder(orderNumber) {
  const orders = getAllOrders();
  const filtered = orders.filter(o => o.orderNumber !== orderNumber);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
}

